import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  carFirmwaresRequest: ['props'],
  carFirmwaresSuccess: ['data'],
  carFirmwaresFailure: ['error'],

  downloadXlsByFilterRequest: ['params'],
  downloadXlsByFilterSuccess: ['data'],
  downloadXlsByFilterFailure: ['error'],
});

export const CarFirmwaresTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  data: null,
  totalPages: 0,
  error: null,
  fetching: false,
  downloadXlsByFilterFetching: true,
});

/* ------------- Reducers ------------- */

// we're attempting to ...
export const request = state => state.merge(
  {
    fetching: true,
    downloadXlsByFilterFetching: true
  });

// we've successfully ...
export const success = (state, { data }) =>
  state.merge({
    fetching: false,
    error: null,
    data: data ? data.page && data.page > 1 ? [...state.data, ...data.data] : data.data : null,
    totalPages: data && data.totalPages ? data.totalPages : 0,
    downloadXlsByFilterFetching: false
  });

// we've had a problem ...
export const failure = (state, { error }) =>
  state.merge({ 
    fetching: false, 
    downloadXlsByFilterFetching: false,
     error });

export const downloadXlsByFilterRequest = (state, {data}) => state.merge(
  {
    downloadXlsByFilterFetching: true
  });

  
export const downloadXlsByFilterSuccess = state => state.merge(
  {
    downloadXlsByFilterFetching: false
  });
/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.CAR_FIRMWARES_REQUEST]: request,
  [Types.CAR_FIRMWARES_SUCCESS]: success,
  [Types.CAR_FIRMWARES_FAILURE]: failure,
  [Types.DOWNLOAD_XLS_BY_FILTER_REQUEST]: downloadXlsByFilterRequest,
  [Types.DOWNLOAD_XLS_BY_FILTER_SUCCESS]: downloadXlsByFilterSuccess,
  [Types.DOWNLOAD_XLS_BY_FILTER_FAILURE]: failure,
});
